const TEST_COURSE_ID = '1e25cc71-a3e0-4a70-a574-5322a8e95fe5';

type CourseAccess = {
  courseId: string;
  courseLevel: string;
};

type ClassCourseAccess<TCourse extends CourseAccess> = {
  courses: readonly TCourse[];
};

export const deriveAvailableCourses = <TCourse extends CourseAccess>(
  classes: readonly ClassCourseAccess<TCourse>[] | null | undefined,
): TCourse[] => {
  const coursesById = new Map<string, TCourse>();

  for (const clas of classes ?? []) {
    for (const course of clas.courses) {
      if (course.courseLevel && !coursesById.has(course.courseId)) {
        coursesById.set(course.courseId, course);
      }
    }
  }

  const courses = [...coursesById.values()];
  const visibleCourses =
    courses.length === 1 ? courses : courses.filter((course) => course.courseId !== TEST_COURSE_ID);

  return visibleCourses.sort((a, b) => a.courseId.localeCompare(b.courseId));
};
